import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';

import { store, persistor } from './store/store';
import { AuthProvider } from './context/AuthContext';
import { CustomerProvider } from './context/CustomerContext';
import { GuestProvider } from './context/GuestContext';
import App from './App';
import './index.css';
import Loading from './components/landing/layout/Loader';
import ReturnChatLoader from './components/common/ReturnChatLoader';

const isReturnChat = window.location.pathname.toLowerCase().includes('/customer/return-chat');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={isReturnChat ? <ReturnChatLoader /> : <Loading />} persistor={persistor}>
        <Router>
          <AuthProvider>
            <GuestProvider>
            <CustomerProvider>
              <App />
            </CustomerProvider>
            </GuestProvider>
          </AuthProvider>
        </Router>
      </PersistGate>
    </ReduxProvider>
  </StrictMode>
);
